import { Download } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconDownload(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Download />
    </IconWrapper>
  );
}
